<template>
  <div class="captcha">
    <div id="captcha-box"></div>
    <div id="captcha" v-show="false"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      instance: {},
      isVerify: false
    }
  },
  props: {
    verify: {
      type: Function,
      default: (nvc) => Promise
    }
  },
  methods: {
    startVerify() {
      const captcha = document.querySelector('#captcha')

      // 触发人机验证点击
      captcha.click()
    },
    getInstance(ins) {
      this.instance = ins
    },
    onBizResultCallback(bizResult) {
      // this.$emits('success')
    },
    captchaVerifyCallback(nvc) {
      return new Promise(resolve => {
        this.verify(nvc).then(res => {
          if (!res) {
            this.isVerify = true
            return resolve({
              captchaResult: res,
              bizResult: false
            })
          }

          if (res) {
            resolve({
              captchaResult: true,
              bizResult: false
            })
          }
        })
      })
    }
  },
  mounted() {
    // 验证码
    window.initAliyunCaptcha({
      SceneId: '1edx6ls2', // 场景ID。根据步骤二新建验证场景后，您可以在验证码场景列表，获取该场景的场景ID
      prefix: '7g77av', // 身份标。开通阿里云验证码2.0后，您可以在控制台概览页面的实例基本信息卡片区域，获取身份标
      mode: 'popup', // 验证码模式。popup表示要集成的验证码模式为弹出式。无需修改
      element: '#captcha-box', // 页面上预留的渲染验证码的元素，与原代码中预留的页面元素保持一致。
      button: '#captcha', // 触发验证码弹窗的元素。button表示单击登录按钮后，触发captchaVerifyCallback函数。您可以根据实际使用的元素修改element的值
      captchaVerifyCallback: this.captchaVerifyCallback, // 业务请求(带验证码校验)回调函数，无需修改
      onBizResultCallback: this.onBizResultCallback, // 业务请求结果回调函数，无需修改
      getInstance: this.getInstance, // 绑定验证码实例函数，无需修改
      language: 'cn', // 验证码语言类型，支持简体中文（cn）、繁体中文（tw）、英文（en）
      immediate: false, // 完成验证后，是否立即发送验证请求（调用captchaVerifyCallback函数）
      region: 'cn', //验证码示例所属地区，支持中国内地（cn）、新加坡（sgp）
      slideStyle: {
        width: '320'
      }
    })
  }
}

</script>

<style lang="less" scoped>
.captcha {
  --aliyun-slide-width: 100%;
  // margin-top: 20px;
}
</style>


// WEBPACK FOOTER //
// src/pages/login/components/nvc.vue